export default __webpack_public_path__ + "static/media/Vector2.da7557f5.svg";